import { FEATURES_TYPES_ITEMS } from './feature-type-selector.const';

// Private

// Public
const getFeatureTypeItems = (isFeatureOn) =>
	FEATURES_TYPES_ITEMS.map((fti) => ({
		...fti,
		items: fti.items.map((item) => {
			const { featureFlag, ...featureTypeItem } = item;
			if (featureFlag) {
				featureTypeItem.disabled = !isFeatureOn(featureFlag);
			}
			return featureTypeItem;
		}),
	})).filter((fti) => !fti.showOnlyIfHasAvailableItems || fti.items.some((item) => !item.disabled));

const FeatureTypeSelectorService = { getFeatureTypeItems };

export default FeatureTypeSelectorService;
